<div class="content-wrapper">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <div class="card col-md-10 col-12">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <h2 class="card-title" style="
                    font-family: 'Times New Roman',Times, serif;
                    font-style: italic; 
                    font-weight: bold;">{{ project.name?.toUpperCase() }}</h2>
                    <p class="card-title" style="color: grey; font-size: medium;">
                        {{project.userName}} {{project.userLastName}}
                        <br>
                        {{ project.createdAt | date:'dd/MM/yyyy' }}
                    </p>
                </div>
                <p class="card-text">
                    {{project.description}}
                </p>
                <p class="card-text">
                    Bütçe : {{project.budget}}
                </p>
            </div>
            <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-icon btn-danger" appDelete
                    controller="projects" [id]="project.id" (callback)="eventDelete()" rippleEffect>
                    <span [data-feather]="'trash'"></span>
                </button>
            </div>
        </div>

        <ul ngbNav #nav="ngbNav" class="nav-tabs">
            <li ngbNavItem>
                <a ngbNavLink>İşlemler</a>
                <ng-template ngbNavContent>
                    <ngx-datatable [rows]="rows" [rowHeight]="58" class="bootstrap core-bootstrap" [limit]="10"
                        [messages]="{ 
                            emptyMessage: 'Veri Yok',
                            totalMessage: 'Toplam', 
                            selectedMessage: 'Seçili'
                          }" [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50"
                        [scrollbarH]="true">
                        <ngx-datatable-column name="Firma Adı" prop="companyName" [width]="120"></ngx-datatable-column>
                        <ngx-datatable-column name="İşlem No" prop="no" [width]="250"></ngx-datatable-column>
                        <ngx-datatable-column name="Tür Adı" prop="typeName" [width]="120"></ngx-datatable-column>
                    </ngx-datatable>
                </ng-template>
            </li>

            <li ngbNavItem>
                <a ngbNavLink>Dosyalar</a>
                <ng-template ngbNavContent>
                    <div class="card">
                        <div class="row ml-1">
                            <div class="form-group col-md-5 mt-1">
                                <input type="file" accept=".doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx, .txt"
                                    class="custom-file-input" id="customFile" (change)="onFileSelected($event)" />
                                <label class="custom-file-label" for="customFile">{{ fileName }}</label>
                            </div>
                            <div class="col-md-2 col-12 mt-1">
                                <button type="button" class="btn btn-success btn-sm d-flex align-items-center mb-1"
                                    [disabled]="selectedFiles.length < 1" (click)="createFile()">
                                    Dosya Ekle
                                </button>
                            </div>
                        </div>
                        <div class="card-body table-responsive">

                            <ngx-datatable [rows]="files" [rowHeight]="50" class="bootstrap core-bootstrap"
                                style="cursor: pointer;" [messages]="{ 
                            emptyMessage: 'Veri Yok',
                            totalMessage: 'Toplam', 
                            selectedMessage: 'Seçili'
                          }" [limit]="5" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
                                [scrollbarH]="true">

                                <ngx-datatable-column name="Dosya Adı" prop="fileName"
                                    [width]="200"></ngx-datatable-column>
                                <ngx-datatable-column name="Dosya Türü" [width]="200">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{ getFileExtension(row.fileName) }}
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="" [width]="120" [sortable]="false">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        <div class="row justify-content-evenly">
                                            <a [href]="row.path" class="mr-1">
                                                <i data-feather="arrow-down" class="text-success cursor-pointer"></i>
                                            </a>
                                            <a appDelete controller="RequestTasks" [id]="row.id"
                                                action="RemoveRequestFile"
                                                (callback)="getByIdRequestTask(requestTask.id)">
                                                <i data-feather="trash" class="text-danger cursor-pointer"></i>
                                            </a>
                                        </div>
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-footer>
                                    <ng-template ngx-datatable-footer-template>
                                        <div class="datatable-footer-inner">
                                            <div class="page-count">
                                                Toplam Veri {{ totalCount }}
                                            </div>
                                            <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10"
                                                [(page)]="pageBasic" (pageChange)="onPageChange($event)">
                                                <ng-template ngbPaginationPrevious>
                                                    <span [data-feather]="'chevron-left'" [size]="18"
                                                        [class]="'font-weight-bolder'"></span>
                                                </ng-template>
                                                <ng-template ngbPaginationNext>
                                                    <span [data-feather]="'chevron-right'" [size]="18"
                                                        [class]="'font-weight-bolder'"></span>
                                                </ng-template>
                                            </ngb-pagination>
                                        </div>
                                    </ng-template>
                                </ngx-datatable-footer>
                            </ngx-datatable>
                        </div>
                    </div>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
</div>